<app-modal-header [title]="'Share this page via:'"></app-modal-header>
<div class="modal-body py-4">
    <div (click)="pinterestShare()" class="action">
        <div class="icon"><app-pinterest-share [simpleIcon]="true"></app-pinterest-share></div>
        <div class="text">Pinterest</div>
    </div>
    <div (click)="twitterShare()" class="action">
        <div class="icon"><app-twitter-share></app-twitter-share></div>
        <div class="text">Twitter</div>
    </div>
    <div (click)="facebookShare()" class="action">
        <div class="icon"><app-facebook-share [simpleIcon]="true"></app-facebook-share></div>
        <div class="text">Facebook</div>
    </div>

    <div (click)="reminder($event)" class="action spacer">
        <div class="icon">
            <div class="icon"><app-icon [type]="'brain'" class="email-icon"></app-icon></div>
        </div>
        <div class="text">Remind</div>
    </div>
    <div (click)="emailShare()" class="action">
        <div class="icon"><app-icon [type]="'Email'" class="email-icon"></app-icon></div>
        <div class="text">Email</div>
    </div>
</div>
